import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const navItems = [
  { to: "/inventory", label: "Overview", end: true, testid: "nav-inv-overview" },
  { to: "/inventory/products", label: "Products", testid: "nav-inv-products" },
  { to: "/inventory/categories", label: "Categories", testid: "nav-inv-categories" },
  { to: "/inventory/warehouses", label: "Warehouses", testid: "nav-inv-warehouses" },
  { to: "/inventory/stock", label: "Stock", testid: "nav-inv-stock" },
  { to: "/inventory/movements", label: "Movements", testid: "nav-inv-movements" },
];

export default function InventoryLayout({ title, children, right }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    toast.success("Signed out.");
    navigate("/login", { replace: true });
  };

  return (
    <div
      data-testid="inventory-page"
      className="min-h-screen bg-[#F9F9F6] text-slate-900"
    >
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 py-5 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button
              data-testid="inv-back-to-dashboard"
              onClick={() => navigate("/dashboard")}
              className="w-7 h-7 bg-[#0A0A0B]"
              aria-label="Back to dashboard"
            />
            <div className="flex flex-col">
              <span className="text-[10px] uppercase tracking-[0.3em] font-semibold text-slate-500">
                Sprint&nbsp;03 · Inventory
              </span>
              <span
                data-testid="inv-user-identifier"
                className="text-xs font-mono text-slate-700 mt-0.5"
              >
                {user?.email || user?.phone} · {user?.role}
              </span>
            </div>
          </div>
          <button
            data-testid="inv-logout-button"
            onClick={onLogout}
            className="h-10 px-5 border border-slate-300 text-sm font-medium rounded-sm hover:bg-slate-50 transition-colors"
          >
            Sign out
          </button>
        </div>

        {/* Nav row */}
        <div className="max-w-7xl mx-auto px-6 sm:px-10 flex gap-6 overflow-x-auto">
          {navItems.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.testid}
              className={({ isActive }) =>
                `py-3 text-xs uppercase tracking-[0.2em] font-semibold border-b-2 -mb-px transition-colors whitespace-nowrap ${
                  isActive
                    ? "border-[#002FA7] text-[#002FA7]"
                    : "border-transparent text-slate-500 hover:text-slate-900"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 sm:px-10 py-10">
        <div className="flex items-center justify-between mb-8">
          <h1
            data-testid="inv-page-title"
            style={{ fontFamily: "'Outfit', sans-serif" }}
            className="text-3xl sm:text-4xl font-semibold tracking-tight leading-none"
          >
            {title}
          </h1>
          <div>{right}</div>
        </div>
        {children}
      </main>
    </div>
  );
}
